import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { I18nKey } from "../../../i18n/i18n";

export type ProfileTabId = "account" | "security" | "privacy";

export const PROFILE_ACCOUNT_PATH = "/profile";
export const PROFILE_SECURITY_PATH = "/profile/security";
export const PROFILE_PRIVACY_PATH = "/profile/privacy";

export type ProfileNavItem = {
  id: ProfileTabId;
  label: I18nKey;
  icon: IconProp;
  link: string;
};

export const PROFILE_NAV_ITEMS: ProfileNavItem[] = [
  {
    id: "account",
    // i18n.t("profile-tab-account")
    label: "profile-tab-account",
    icon: "user",
    link: PROFILE_ACCOUNT_PATH,
  },
  {
    id: "security",
    // i18n.t("profile-tab-security")
    label: "profile-tab-security",
    icon: "lock",
    link: PROFILE_SECURITY_PATH,
  },
  {
    id: "privacy",
    // i18n.t("profile-tab-privacy")
    label: "profile-tab-privacy",
    icon: "user-shield",
    link: PROFILE_PRIVACY_PATH,
  },
];

export const isProfilePath = (pathname: string) =>
  pathname === PROFILE_ACCOUNT_PATH ||
  pathname.startsWith(`${PROFILE_ACCOUNT_PATH}/`);
